import React,{useState} from 'react'
import ExchangeRate from "./ExchangeRate"
import axios from 'axios'
import {Button, Typography} from '@material-ui/core';

const CryptoConveter = () => {
    const currencies = ['BTC', 'ETH', 'USD', 'XRP', 'LTC']
    const [chosenPrimaryCurrency, setChosenPrimaryCurrency] = useState('BTC')
    const [chosenSecondaryCurrency, setChosenSecondaryCurrency] = useState('USD')
    const [amount, setAmount] = useState(1)
    const [exchangeRate, setExchangeRate] = useState(1)
    const [result, setResult] = useState(0)
    console.log(amount);

    const convert = () => {
        

        const options = {
            method: 'GET',
            url: 'https://alpha-vantage.p.rapidapi.com/query',
            params: {from_currency: chosenPrimaryCurrency, function: 'CURRENCY_EXCHANGE_RATE', to_currency: chosenSecondaryCurrency},
            headers: {
                'x-rapidapi-host': 'alpha-vantage.p.rapidapi.com',
                'x-rapidapi-key': '3a5da310camsh23eda33e06b903ep190ed9jsn52323cba3df5'
        }
    };

    axios.request(options).then((response) => {
        console.log(response.data);
        setExchangeRate(response.data['Realtime Currency Exchange Rate'] ['5. Exchange Rate'])
        setResult(response.data['Realtime Currency Exchange Rate'] ['5. Exchange Rate'] * amount)
    }).catch((error) => {
	    console.error(error);
    });
}

    return (
     
        <div className='crypto-converter'>
            <Typography variant='h4' className='font-bolde ' style={{textAlign: "center"}}>Currency Conveter</Typography>
            <div className='input-box'>

                <table>
                    <tbody>
                        <tr >
                            <tb>Primary Currency:</tb>
                            <tb>
                                <input
                                    type='number'
                                    name='currency-amount-1'
                                    style={{maxWidth: 125}}
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                />
                            </tb>
                            <tb>
                                <select
                                    name='currency-option-1'
                                    value={chosenPrimaryCurrency}
                                    className='currency-options'
                                    onChange={(e) => setChosenPrimaryCurrency(e.target.value)}
                                >
                                    {currencies.map((currency, _index) => ( <option key={_index}>{currency}</option>))}
                                </select>
                            </tb>
                        </tr>
                        <tr>
                            <tb>Secondary Currency:</tb>
                            <tb>
                                <input
                                    name='currency-amount-2'
                                    value={result}
                                    disabled={true}
                                    style={{maxWidth: 125}}
                                />
                            </tb>
                            <tb>
                                <select
                                    name='currency-option-2'
                                    value={chosenSecondaryCurrency}
                                    className='currency-options'
                                    onChange={(e) => setChosenSecondaryCurrency(e.target.value)}
                                >
                                    {currencies.map((currency, _index) => ( <option key={_index}>{currency}</option>))}
                                </select>
                            </tb>
                        </tr>
                    </tbody>
                </table>

                <Button variant='contained' color='success' id="convert-button" onClick={convert}>Convert</Button>

            </div>
            <ExchangeRate exchangeRate={exchangeRate} chosenPrimaryCurrency={chosenPrimaryCurrency} chosenSecondaryCurrency={chosenSecondaryCurrency} />
        </div>
       
    )
}

export default CryptoConveter
